import React from 'react';
import { Cloud, CloudOff, RefreshCw, AlertCircle, Check } from 'lucide-react';
import { useSyncQueue } from '../../hooks/useSyncQueue';

const SyncIndicator = () => {
    // Disabled - sync status is shown in RoutineHeader instead
    // This avoids duplicate indicators and visual clutter
    return null;
};

export default SyncIndicator;
